import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Layout as AntdLayout, Col, Menu, Row } from "antd";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/header/logo.svg";
import { useTranslation } from "../../others/i18n.js";
import { useStores } from "../../store/root.js";
import { ESessionState } from "../../types/store/authentication.js";
import { getItem } from "../../util/menu.js";
import { RcbAvatar } from "../route/real-cookie-banner/rcb-avatar.js";
const { Header: AntHeader } = AntdLayout;
const Header = ({ headerHeight, activeAdminService })=>{
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { rcbAuthenticationStore } = useStores();
    const { sessionState } = rcbAuthenticationStore;
    const menuItems = [
        getItem({
            label: t("Real Cookie Banner"),
            key: "rcb"
        }),
        getItem({
            label: t("Real Commerce"),
            key: "rc"
        }),
        getItem({
            label: t("Real Product Manager"),
            key: "rpm"
        })
    ];
    const onMenuClick = (menuItem)=>navigate(`/${menuItem.key}${sessionState === ESessionState.None ? "/login" : ""}`, {
            replace: true
        });
    return /*#__PURE__*/ _jsx(AntHeader, {
        style: {
            height: headerHeight,
            padding: "0 20px"
        },
        children: /*#__PURE__*/ _jsxs(Row, {
            style: {
                height: headerHeight
            },
            children: [
                /*#__PURE__*/ _jsx(Col, {
                    flex: "280px",
                    children: /*#__PURE__*/ _jsx(Link, {
                        to: "/",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: Logo,
                            style: {
                                height: `calc(${headerHeight}px - 18px)`,
                                margin: "9px 14px 9px 0"
                            }
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Col, {
                    flex: "auto",
                    children: /*#__PURE__*/ _jsx(Menu, {
                        onClick: onMenuClick,
                        theme: "dark",
                        mode: "horizontal",
                        selectedKeys: [
                            activeAdminService
                        ],
                        items: menuItems
                    })
                }),
                /*#__PURE__*/ _jsx(Col, {
                    hidden: !rcbAuthenticationStore.session?.user,
                    children: /*#__PURE__*/ _jsx(RcbAvatar, {
                        user: rcbAuthenticationStore.session?.user,
                        showLogout: true
                    })
                })
            ]
        })
    });
};
export { Header };
